export enum TenantFeatures {
	Forecasting = "forecasting",
	EnableV2 = "enableV2",
	FirstTimeLogin = "firstTimeLogin",
	TenantInfo = "tenantInfo",
	RichTextInput = "richText",
	Suite = "Suite",
	DisableRichTextInsightsCSVSanitization = "DisableRichTextInsightsCSVSanitization",
	DataSourceLimit500 = "dataSourceItemLimit500",
	PdfTemplates = "pdfTemplates",
	PdfTemplateHeaderAndFooter = "pdfTemplateHeaderAndFooter",
	RuleActionRemoveField = "ruleActionRemoveField",
	AllowLockedFieldsToBeEdited = "allowLockedFieldsToBeEdited",
	RedirectUserAfterInterceptedLogin = "redirectUserAfterInterceptedLogin",
	SendEmail = "sendEmail",
	SyncAreaParentChanges = "syncAreaParentChanges",
	PdfTemplatesAttachToEmail = "pdfTemplatesAttachToEmail",
	AreaScaling = "areaScaling",
	ConfigureLandingPage = "configureLandingPage",
	ReopenClosedCases = "reopenClosedCases",
}
